import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>
            <span className="company-name-line1">Milestone Construction</span>
            <span className="company-name-line2">Services Co.</span>
          </h1>
          <p className="slogan">Your vision, our precision</p>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
        <div className="container">
          <div className="about-content">
            <h2>About NJ-MCS</h2>
            <p>
              NJ-MCS has been a trusted name in the construction industry for over 10 years. 
              We specialize in residential and commercial construction, renovation, and remodeling projects. 
              Our team of skilled professionals is committed to delivering exceptional results that exceed 
              our clients' expectations.
            </p>
            <p>
              From initial concept to final completion, we work closely with our clients to ensure every 
              project reflects their vision while maintaining the highest standards of quality and safety. 
              Our dedication to excellence and customer satisfaction has made us a preferred choice for 
              construction projects throughout the region.
            </p>
            <div className="stats">
              <div className="stat">
                <h3>500+</h3>
                <p>Projects Completed</p>
              </div>
              <div className="stat">
                <h3>10+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat">
                <h3>100%</h3>
                <p>Client Satisfaction</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview">
        <div className="container">
          <h2>Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🏠</div>
              <h3>Home Renovation</h3>
              <p>Complete home transformations and improvements to enhance your living space.</p>
              <Link to="/book-appointment?service=Home Renovation" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🚿</div>
              <h3>Bathroom Remodeling</h3>
              <p>Modern bathroom designs and renovations to create your dream space.</p>
              <Link to="/book-appointment?service=Bathroom Remodeling" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🏠</div>
              <h3>Roofing</h3>
              <p>Professional roofing installation, repair, and maintenance services.</p>
              <Link to="/book-appointment?service=Roofing" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🪵</div>
              <h3>Flooring</h3>
              <p>High-quality flooring installation including hardwood, tile, and carpet.</p>
              <Link to="/book-appointment?service=Flooring" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🧱</div>
              <h3>Sheetrock</h3>
              <p>Professional drywall installation, repair, and finishing services.</p>
              <Link to="/book-appointment?service=Sheetrock" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🎨</div>
              <h3>Paint</h3>
              <p>Interior and exterior painting services with premium quality finishes.</p>
              <Link to="/book-appointment?service=Paint" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🏘️</div>
              <h3>Siding</h3>
              <p>Expert siding installation and repair to protect and beautify your home.</p>
              <Link to="/book-appointment?service=Siding" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🔨</div>
              <h3>Carpentry</h3>
              <p>Custom carpentry work including cabinets, trim, and built-ins.</p>
              <Link to="/book-appointment?service=Carpentry" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🧱</div>
              <h3>Masonry</h3>
              <p>Professional masonry work including brick, stone, and concrete projects.</p>
              <Link to="/book-appointment?service=Masonry" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🪑</div>
              <h3>Furniture Assembly</h3>
              <p>Professional furniture assembly and setup services for your home.</p>
              <Link to="/book-appointment?service=Furniture Assembly" className="book-button">Book an appointment</Link>
            </div>
            <div className="service-card">
              <div className="service-icon">🗑️</div>
              <h3>Junk Removal</h3>
              <p>Complete junk removal and debris cleanup services for your property.</p>
              <Link to="/book-appointment?service=Junk Removal" className="book-button">Book an appointment</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us">
        <div className="container">
          <h2>Why Choose NJ-MCS?</h2>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">⭐</div>
              <h3>Quality Assurance</h3>
              <p>We use only the finest materials and employ skilled craftsmen to ensure lasting quality.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">⏰</div>
              <h3>On-Time Delivery</h3>
              <p>Our project management expertise ensures your project is completed on schedule.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">💰</div>
              <h3>Competitive Pricing</h3>
              <p>Transparent pricing with no hidden costs - you get excellent value for your investment.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🛡️</div>
              <h3>Licensed & Insured</h3>
              <p>Fully licensed, bonded, and insured for your peace of mind and protection.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
